import { ReactNode } from "react";
import { Container } from "../styled";

interface GenericPointBalanceProps {
	id?: string;
	children: ReactNode;
	//onClick?: MouseEventHandler<HTMLDivElement>;
}

export const GenericPointBalance = ({
	id,
	children
}: GenericPointBalanceProps) => {
	return <Container id={id}>{children}</Container>;
};
